<template>
  <b-navbar variant="light" toggleable="lg" class="bg-five-fold-yellow">
    <b-container>
      <b-navbar-brand class="ml-2" :to="{name: user? 'home':'welcome'}" :aria-label="$t('nav_home')">
        <fa icon="home" />
      </b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="{name: 'static.paper-version'}">
            {{ $t('nav_paper_version') }}
          </b-nav-item>
          <b-nav-item :to="{name: 'staticContents.showByIdentifier', params: { identifier: 'learn_about_the_five_fold_ministry' }}">
            {{ $t('nav_learn_about_the_fivefold_ministry') }}
          </b-nav-item>
          <b-nav-item href="https://fivefoldministrytest.givingfuel.com/donate" target="_blank">
            {{ $t('nav_support_this_project') }}
          </b-nav-item>
          <b-nav-item :to="{name: 'contact'}">
            {{ $t('nav_contact') }}
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <locale-dropdown />
          <user-dropdown v-if="user" />
          <template v-else>
            <b-nav-item :to="{ name: 'login' }">
              {{ $t('login') }}
            </b-nav-item>
            <b-nav-item :to="{ name: 'register' }">
              {{ $t('register') }}
            </b-nav-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'
import UserDropdown from '~/components/UserDropdown.vue'

export default {
  components: {
    UserDropdown,
    LocaleDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  })

}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>
